import { Component, Vue } from 'vue-property-decorator'
import { getMarketClueById } from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { getMessageRemindById } from "@/api/message";

@Component({
})
export default class SeeClue extends Vue {
    // ------ 变量 ------
    marketClue: any = {}
    activities = []
    operationShow = true
    marketId = 0
    status = ''
    loading = false

    // ------ 生命周期 ------
    created() {
        // this.marketId = Number(this.$route.query.id)
        // this.status = (this.$route.query.status as string) || ''
        // this.getMarketClueById()

        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.getMsgData(recordId)
    }

    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any)=>{
            this.marketClue = data.result.messageRemindInfo
            this.activities = this.marketClue.market_clue_logs
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    // ------ 方法 ------
    async getMarketClueById() {
        const data: any = await getMarketClueById({ id: this.marketId })
        this.marketClue = data.marketClue
        this.activities = this.marketClue.market_clue_logs
    }
    formatDate(format: string, val: Date) {
        return formatDate(format, new Date(val))
    }
    buttonShow(id: number): boolean {
        return menuBtn(id)
    }
}